import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql, compose } from "react-apollo";
import moment from "moment";
import {
  queryGetLabelsByType,
  mutationAddLabelToCase,
  mutationDeleteLabelFromCase
} from "Apollo";
import { ShowNotice } from "Store";
import TreeLabelList from "module-common/label-list/TreeLabelList";

export default compose(
  graphql(queryGetLabelsByType, {
    name: "labelsData",
    options: { variables: { type: "CASE" } }
  }),
  graphql(mutationAddLabelToCase, { name: "mutateAdd" }),
  graphql(mutationDeleteLabelFromCase, { name: "mutateDelete" })
)(
  class LabelListCase extends Component {
    static propTypes = {
      id: PropTypes.number.isRequired,
      labels: PropTypes.array
    };
    state = { treeLabels: [] };

    componentWillReceiveProps(nextProps) {
      const {
        labelsData: { getLabelTemplates: labelsPicker }
      } = nextProps;
      const allLabelMap = new Map();
      if (labelsPicker) {
        for (const label of labelsPicker) {
          allLabelMap.set(label.id, {
            label: label.displayName,
            isCollapsed: true,
            value: label,
            children: []
          });
        }
      }

      const treeLabels = [];
      for (const label of allLabelMap.values()) {
        // order in tree
        if (label.value.parentId === -1) {
          treeLabels.push(label);
        } else {
          const select = allLabelMap.get(label.value.parentId);
          if (select) {
            select.children.push(label);
          }
        }
      }
      this.setState({ treeLabels: treeLabels });
    }

    render() {
      const { labels, ...rest } = this.props;
      const { treeLabels } = this.state;

      // labels
      const caseLabels = [];
      for (const label of labels) {
        const currLabel = label.labelTemplate;
        if (currLabel.labelType === "CASE") {
          caseLabels.push({
            label: currLabel.displayName,
            color: "#" + currLabel.color,
            value: currLabel
          });
        }
      }
      // sort by order and date
      caseLabels.sort((a, b) => {
        if (a.value.order !== b.value.order) {
          return a.value.order > b.value.order;
        } else {
          return moment(a.value.dateCreated).isAfter(b.value.dateCreated);
        }
      });

      return (
        <TreeLabelList
          maxMenuScroll={3}
          labels={caseLabels}
          tree={treeLabels}
          onAdd={this.onAdd}
          onRemove={this.onRemove}
          onChange={treeLabels => this.setState(treeLabels)}
          {...rest}
        />
      );
    }

    onAdd = async label => {
      const { id, mutateAdd } = this.props;
      try {
        await mutateAdd({
          variables: {
            case: { id: id },
            labels: [{ id: label.value.id }]
          }
        });
        ShowNotice("label-add-success");
      } catch (error) {
        ShowNotice("label-add-error");
      }
    };

    onRemove = async label => {
      const { id, mutateDelete } = this.props;
      try {
        await mutateDelete({
          variables: {
            case: { id: id },
            labels: [{ id: label.value.id }]
          }
        });
        ShowNotice("label-delete-success");
      } catch (error) {
        ShowNotice("label-delete-error");
      }
    };
  }
);



// WEBPACK FOOTER //
// ./src/module-case-management/info-panel/TreeLabelListCaseWithQueryMutation.js